.data-table__container {
  height: 100%;
  overflow-y: auto;
  position: relative;
  width: 100%;
}

.data-table__spacer {
  background-color: transparent;
  width: 0.0625rem;
}

.data-table {
  border-collapse: collapse;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.data-table--virtualized {
  border-collapse: collapse;
  left: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
}

.data-table__row,
.data-table__header-row {
  background-color: var(--color-uva-white);
  border-bottom: 0.0625rem solid var(--color-grey-300);
}

.data-table__header-row {
  border-left: 0.0625rem solid transparent;
  border-right: 0.0625rem solid transparent;
}

.data-table__row {
  border-left: 0.0625rem solid var(--color-grey-300);
  border-right: 0.0625rem solid var(--color-grey-300);
}

.data-table__row--hoverable:hover {
  background-color: var(--color-grey-200);
  cursor: pointer;
}

.data-table__row--active {
  background-color: var(--color-navy-100);
}

.data-table__row--active.data-table__row--hoverable:hover {
  background-color: var(--color-navy-200);
}

.data-table__cell {
  overflow: hidden;
  padding: 0.6875rem 0.75rem;
  text-align: left;
  vertical-align: baseline;
}

.data-table__sticky-header {
  background-color: var(--color-uva-white);
  left: 0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.data-table__sticky-header::after {
  border-bottom: 0.0625rem solid var(--color-grey-300);
  content: "";
  display: block;
  height: 0.0625rem;
  left: 0;
  position: absolute;
  top: 100%;
  width: 100%;
}

.data-table__empty-state {
  color: var(--color-grey-600);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}
